import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { SettingsPermissions } from "@redotech/redo-model/permissions";

export const conversionRoutes: PermissionedRouteObject = {
  handle: {
    breadcrumb: "Conversion",
    breadcrumbNavigate: false,
    permission: [
      SettingsPermissions.SET_TNPL_SETTINGS,
      SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
    ],
  },
  path: "conversion",
  children: [
    {
      handle: {
        breadcrumb: "Try first",
        breadcrumbNavigate: false,
        permission: SettingsPermissions.SET_TNPL_SETTINGS,
      },
      path: "try-first",
      children: [
        {
          index: true,
          lazy: async () => {
            const { TryFirstPage } = await import("./try-first/try-first");
            return { Component: TryFirstPage };
          },
        },
        {
          handle: {
            breadcrumb: "Cart optimization",
            breadcrumbNavigate: false,
            permission: SettingsPermissions.SET_TNPL_SETTINGS,
          },
          path: "cart-optimization",
          lazy: async () => {
            const { CartOptimizationPage } = await import(
              "./cart-optimization/cart-optimization"
            );
            return { Component: CartOptimizationPage };
          },
        },
      ],
    },
    {
      path: "general",
      handle: {
        breadcrumb: "General",
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { ConversionGeneralSettingsPage } = await import(
              "./general/conversion-general-settings-page"
            );
            return { Component: ConversionGeneralSettingsPage };
          },
        },
        {
          path: "checkout-widgets-builder",
          handle: {
            breadcrumb: "Widget builder",
            permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
          },
          lazy: async () => {
            const { UpdateCheckoutExperienceWidgetsPage } = await import(
              "../../conversion/checkout-experiences/widgets/update-checkout-experience-widgets-page"
            );
            return { Component: UpdateCheckoutExperienceWidgetsPage };
          },
        },
      ],
    },
  ],
};
